import { connect } from "react-redux";
import React, { useRef, useState } from "react";
import Select from "react-select";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import enhancer from "./enhancer/StaffEnhancer";
import { compose } from "redux";
import { addStaff, editStaff } from "services/staffServices";
import NavigationActions from "redux/navigation/actions";
import { useEffect } from "react";
import Loader from "components/Loader";
import { getAllVenues } from "services/venueServices";
import { getServiceByVenue } from "services/serviceServices";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;

const StaffModal = props => {
  const { isEdit } = props;
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    isValid,
    setValues,
    onClose,
    toggleRefresh,
    setFieldError,
    handleSubmit,
    editData
  } = props;

  const [loading, setLoading] = useState(false);
  const [venueData, setVenueData] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const fileInputRef = useRef(null);
  const isInitialServiceLoad = useRef(true);

  const StaffHandler = async e => {
    e.preventDefault();
    handleSubmit(e);
    // console.log(values.is_manager)
    if (isValid) {
      const formData = new FormData();
      // console.log("VALUS: :",values)
      formData.append("file_image", values.file_image);
      formData.append("name", values.name);
      formData.append("email", values.email.toLowerCase());
      formData.append("phone", values.phone);
      formData.append("status", values.status);
      formData.append("is_manager", values.is_manager);
      if (Array.isArray(values.venue_data)) {
        formData.append(
          "venue_data",
          JSON.stringify(values.venue_data.map(v => v.value))
        );
      } else if (values.venue_data) {
        formData.append("venue_data", JSON.stringify([values.venue_data]));
      } else {
        formData.append("venue_data", JSON.stringify([]));
      }
      if (Array.isArray(values.service_data)) {
        formData.append(
          "service_data",
          JSON.stringify(values.service_data.map(item => item.value))
        );
      } else if (values.service_data) {
        formData.append("service_data", values.service_data);
      } else {
        formData.append("service_data", "");
      }

      setLoading(true);
      // console.log("IS EDIT : ",isEdit);
      // console.log("FormData : ",formData)
      isEdit
        ? await editStaff(token, values._id, formData).then(res => {
            if (res.success) {
              success(res.message);
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
            }
            setLoading(false);
          })
        : await addStaff(token, formData).then(res => {
            if (res.success) {
              success(res.message);
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
            }
            setLoading(false);
          });
    }
  };

  const getVenuesData = async () => {
    await getAllVenues(token)
      .then(res => {
        let venueOptions = res.data.map(venue => {
          return { value: venue._id, label: venue.name };
        });
        setVenueData(venueOptions);
      })
      .catch(err => {
        error(err.message);
      });
  };

  const getServiceDataByVenue = async (venueIds = null) => {
    const targetVenues =
      venueIds ||
      (Array.isArray(selectedVenues) ? selectedVenues.map(v => v.value) : []);
    if (!targetVenues || targetVenues.length === 0) return;

    // Assuming API can accept array, otherwise loop and merge results
    return await getServiceByVenue(token, { selectedVenue: targetVenues })
      .then(res => {
        let serviceArr = res.data?.map((val, i) => {
          return { value: val._id, label: val.name };
        });
        setServiceData(serviceArr);
        return res;
      })
      .catch(err => {
        error(err.message);
      });
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const handleImageChange = e => {
    if (e.target.files.length !== 1) {
      return;
    }
    const file = e.target.files[0];
    // console.log("File: ",file)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      setFieldError(e.target.name, "Only .jpg, .jpeg, .png files are allowed.");
      e.target.value = "";

      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      setFieldError(e.target.name, "File size should be less than 2MB.");
      e.target.value = "";
      return;
    }

    setFieldValue(e.target.name, file);
    fileInputRef.current.value = "";
  };

  // Function to convert service_data array to select options format
  const convertServiceDataToOptions = (serviceIds, availableServices) => {
    if (!Array.isArray(serviceIds) || !Array.isArray(availableServices)) {
      return [];
    }

    return serviceIds.map(serviceId => {
      const service = availableServices.find(s => s.value === serviceId);
      return service || { value: serviceId, label: `Service ${serviceId}` };
    });
  };

  useEffect(() => {
    if (isEdit && editData) {
      setValues({ ...editData });
      let venueArr = [];
      if (Array.isArray(editData.venue_data)) {
        venueArr = editData.venue_data.map(v =>
          typeof v === "object"
            ? { value: v._id, label: v.name }
            : venueData.find(opt => opt.value === v) || {
                value: v,
                label: `Venue ${v}`
              }
        );
      } else if (editData.venue_data) {
        const v = editData.venue_data;
        venueArr = [
          typeof v === "object"
            ? { value: v._id, label: v.name }
            : venueData.find(opt => opt.value === v) || {
                value: v,
                label: `Venue ${v}`
              }
        ];
      }
      setSelectedVenues(venueArr);
      setValues({
        ...editData,
        venue_data: venueArr
      });

      // If there's venue data and service data, fetch services for these venues
      if (
        venueArr.length > 0 &&
        editData.service_data &&
        Array.isArray(editData.service_data)
      ) {
        getServiceDataByVenue(venueArr.map(v => v.value)).then(() => {
          // After services are loaded, we'll set the selected services in the next useEffect
        });
      }
    } else if (!isEdit) {
      // Set default is_manager to true for add mode
      setValues(prev => ({ ...prev, is_manager: true }));
    }
  }, [editData, isEdit]);

  // Separate useEffect to handle service data setting after services are loaded
  // useEffect(() => {
  //   if (isEdit && editData && serviceData.length > 0 && editData.service_data) {
  //     // Convert service IDs to select options format
  //     const selectedServices = convertServiceDataToOptions(
  //       editData.service_data,
  //       serviceData
  //     );
  //     setFieldValue("service_data", selectedServices);
  //   }
  // }, [serviceData, isEdit, editData]);

  useEffect(() => {
    // Only run once for initial edit load
    if (
      isEdit &&
      editData &&
      serviceData.length > 0 &&
      editData.service_data &&
      isInitialServiceLoad.current
    ) {
      const selectedServices = convertServiceDataToOptions(
        editData.service_data,
        serviceData
      );
      setFieldValue("service_data", selectedServices);

      isInitialServiceLoad.current = false; // 🔥 never run again
    }
  }, [serviceData]);

  useEffect(() => {
    getVenuesData();
  }, []);

  // Add this useEffect to call API when venue is selected
  useEffect(() => {
    if (selectedVenues && selectedVenues.length > 0) {
      getServiceDataByVenue();
    } else {
      setServiceData([]);
      setFieldValue("service_data", []);
    }
  }, [selectedVenues]);

  useEffect(() => {
    return () => {
      isInitialServiceLoad.current = true;
    };
  }, []);

  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Staff
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label>
              Name <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="name"
              onChange={handleChange}
              value={values.name}
              onBlur={handleBlur}
              placeholder="Staff Name"
            />
            <Error field="name" />
          </div>
          <div className="form-group">
            <label>
              Email <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="email"
              onChange={handleChange}
              value={values.email}
              onBlur={handleBlur}
              placeholder="Staff email"
              disabled={isEdit ? true : false}
            />
            <Error field="email" />
          </div>
          <div className="form-group">
            <label>
              Phone <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="phone"
              onChange={handleChange}
              value={values.phone}
              onBlur={handleBlur}
              placeholder="Staff phone"
            />
            <Error field="phone" />
          </div>
          <div className="form-group">
            <label>Image</label>
            <br />
            <input
              ref={fileInputRef}
              type="file"
              id="file_image"
              name="file_image"
              className="form-control react-form-input"
              accept="image/*"
              onChange={handleImageChange}
              onBlur={handleBlur}
            />
            <Error field="file_image" />
            {values?.file_image && (
              <>
                <br />
                <img
                  src={
                    values?.file_image instanceof Blob
                      ? URL.createObjectURL(values?.file_image)
                      : `${process.env.REACT_APP_UPLOAD_DIR}${values?.file_image}`
                  }
                  className="profile-img"
                  alt="no"
                  width={100}
                  onError={e => {
                    e.target.src = PlaceHolderImage;
                  }}
                />
                <br />
              </>
            )}
          </div>
          <div className="form-group">
            <label>
              Venue <span className="red">*</span>
            </label>
            <Select
              value={values.venue_data || []}
              name="venue_data"
              options={venueData}
              isMulti
              className="basic-multi-select w-100"
              classNamePrefix="select"
              onChange={selected => {
                setFieldValue("venue_data", selected || []);
                setSelectedVenues(selected || []);
                // Clear selected services when venue changes
                setFieldValue("service_data", []);
              }}
              placeholder="Select venue(s)"
            />
            <Error field="venue_data" />
          </div>
          <div className="form-group">
            <label>
              Is Manager <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={
                values?.is_manager !== undefined
                  ? values.is_manager.toString()
                  : "false"
              }
              name="is_manager"
              onChange={e => {
                const isManager = e.target.value === "true";
                setFieldValue("is_manager", isManager);
                if (isManager) {
                  setFieldValue("service_data", []);
                }
              }}
              onBlur={handleBlur}
            >
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <Error field="is_manager" />
          </div>
          {values?.is_manager === false && (
            <div className="form-group">
              <label>
                Services <span className="red">*</span>
              </label>
              <Select
                value={
                  Array.isArray(values.service_data) ? values.service_data : []
                }
                isMulti
                name="service_data"
                options={serviceData}
                className="basic-multi-select w-100"
                classNamePrefix="select"
                onChange={selected => {
                  setFieldValue("service_data", selected || []);
                }}
                isDisabled={
                  !selectedVenues ||
                  selectedVenues.length === 0 ||
                  serviceData.length === 0
                }
                placeholder={
                  !selectedVenues || selectedVenues.length === 0
                    ? "Please select a venue first"
                    : "Select services"
                }
              />
              <Error field="service_data" />
            </div>
          )}
          <div className="form-group">
            <label>
              Status <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={values?.status}
              name="status"
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value={true}>Active</option>
              <option value={false}>Deactive</option>
            </select>
            <Error field="status" />
          </div>
          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              {console.log(isValid, values, "isvalid values")}
              <Button
                onClick={e => StaffHandler(e)}
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={isValid ? false : false}
              >
                {isEdit ? "Update" : "Add"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={() => {
                  onClose();
                }}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading && <Loader />}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  // withRouter,
  enhancer,
  connect(mapStateToProps, { success, error })
)(StaffModal);
